import axios from "axios";

const basePath = `${process.env.REACT_APP_API_VIA_CEP}/ws`;

const fetchAddress = async (zipCode) => {
	try {
		const url = `${basePath}/${zipCode}/json/`;

		const response = await axios.get(url);
		if (response.data) {
			return response.data;
		}

		return null;
	} catch (error) {
		console.error("addressService.fetchAddress", "Error get", error);
		return null;
	}
};

const calculateShipping = async (zipCode) => {
	return 13.30;
}

export const addressService = {
	fetchAddress,
	calculateShipping,
};
